import { validatePassword } from 'firebase/auth'
import i18n from './i18n'

export function validatePasswordRule(auth) {
  return () => ({
    async validator(_, value) {
      if (!value) {
        return Promise.resolve()
      }

      try {
        const status = await validatePassword(auth, value)

        if (status.isValid) {
          return Promise.resolve()
        } else {
          let minErrors = []
          let maxErrors = []
          if (status.meetsMinPasswordLength === false) {
            minErrors.push(
              i18n.t('frontend:validation.password.chars', {
                count:
                  status.passwordPolicy.customStrengthOptions.minPasswordLength,
              })
            )
          }
          if (status.meetsMaxPasswordLength === false) {
            maxErrors.push(
              i18n.t('frontend:validation.password.chars', {
                count:
                  status.passwordPolicy.customStrengthOptions.maxPasswordLength,
              })
            )
          }
          if (status.containsLowercaseLetter === false) {
            minErrors.push(i18n.t('frontend:validation.password.lowercase'))
          }
          if (status.containsUppercaseLetter === false) {
            minErrors.push(i18n.t('frontend:validation.password.uppercase'))
          }
          if (status.containsNumericCharacter === false) {
            minErrors.push(i18n.t('frontend:validation.password.number'))
          }
          if (status.containsNonAlphanumericCharacter === false) {
            minErrors.push(i18n.t('frontend:validation.password.special'))
          }

          const errors = []

          if (minErrors.length > 0) {
            errors.push(
              new Error(
                i18n.t('frontend:validation.password.atLeast', {
                  requirements: minErrors.join(', '),
                })
              )
            )
          }

          if (maxErrors.length > 0) {
            errors.push(
              new Error(
                i18n.t('frontend:validation.password.atMost', {
                  requirements: maxErrors.join(', '),
                })
              )
            )
          }

          return Promise.reject(errors)
        }
      } catch {
        return Promise.resolve()
      }
    },
  })
}
